import React from "react"
import {SingleSelect, SingleSelectProps} from "../../select/single-select"
import {FormField} from "../form-field/form-field"

export interface FormSingleSelectProps extends SingleSelectProps {
  label: string
}

export const FormSingleSelect: React.FC<FormSingleSelectProps> = (props) => {
  return <FormField {...props}>
    <SingleSelect {...props} />
  </FormField>
}

